<template>
	<div class="yixiaolie" style="font-size: 12px;">

		<div class="header">
			<div>
				<div class="borziBtn" v-bind:class="{active:(cepingtai==2)}" @click="ceping(2)">待测评</div>
				<div class="borziBtn" style="margin-left: 10px" v-bind:class="{active:(cepingtai==1)}" @click="ceping(1)">已测评</div>
			</div>



			<div class="sousuok" style="width: 200px">
				<el-input size="mini" placeholder="请输入姓名、电话搜索" v-model="cha" @keyup.native="jiansuo">
					<i class="el-icon-search el-input__icon" slot="suffix">
					</i>
				</el-input>
			</div>

		</div>
		<div class="tableBox">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th>序号</th>
						<th>类型</th>
						<th>家长姓名</th>
						<th>会员姓名</th>
						<th>别名</th>
						<th>预约测评时间</th>
						<th>预约测评师</th>
						<th>性别</th>
						<th>生日</th>
						<th>月龄</th>
						<th>课时</th>
						<th>状态</th>
						<th>历史记录</th>

					</tr>
				</thead>
				<tbody>
					<tr v-for="(fe,index) in list">
						<!--v-for="(fe,index) in fen"-->
						<td v-cloak>{{index+1}}</td>
						<td v-cloak>{{fe.hy_zt}}</td>
						<td v-cloak>{{fe.jz_name}}</td>
						<td v-cloak>{{fe.baobao_name}} </td>
						<td v-cloak>{{fe.baobao_name2}}</td>
						<td v-cloak>{{fe.yy_time}}</td>
						<td v-cloak>{{fe.username}}</td>
						<td v-cloak>{{fe.baobao_sex}}</td>
						<td v-cloak>{{fe.baobao_birthday}}</td>
						<td v-cloak>{{fe.yueling}}</td>
						<td v-cloak>{{fe.y_keshi}}</td>
						<td v-cloak v-if="fe.cp_status==1" style="color:green">{{fe.cp_zt}}</td>
						<td v-cloak v-if="fe.cp_status==3" style="color:#00cce4;cursor: pointer" @click="tiaoyex(fe.list_id)">{{fe.cp_zt}}</td>
						<!--新测评-->
						<td v-cloak v-if="fe.cp_status==4" style="color:#ff797c;cursor: pointer" @click="jumper(fe.list_id,fe.now_num,1)">{{fe.cp_zt}}</td>
						<!--未完成-->

						<td v-cloak style="color:#E6BE8A;cursor: pointer" @click="history(fe.list_id)">查看报告</td>
					</tr>


				</tbody>
			</table>
		</div>
		<p style="padding: 20px 10px 0;color: #999;font-size: 14px" v-cloak>共有<span v-cloak>{{biaonum}}</span>条数据，当前第 <span
			 v-cloak>{{page}} </span> 页共 <span v-cloak>{{pagetotal}}</span>页</p>
		<div class="table-bottom">
			<div>
				<el-pagination @current-change="tan" :page-size="pageone" background layout="prev, pager, next" :total="biaonum">
				</el-pagination>
			</div>
		</div>




	</div>
</template>

<script>
	export default {

		data() {
			return {
				biaonum: 0,
				pageone: 10,
				centre_id: '',
				list: '',
				page: 1,
				pagetotal: '',
				cepingtai: 2,
				cha: '',
				token: ''
			}
		},
		methods: {
			history: function(listid) {
				//            location.href=`history.html?listid=${listid}`
				//            historylc

				this.$router.push({
					name: 'historylc',
					query: {
						listid: listid
					}

				})
			},
			tiaoyex: function(e) {
				//            location.href=`cepingx.html?iid=${e}`
				//            cepingxlc
				this.$router.push({
					name: 'cepingxlc',
					query: {
						iid: e
					}
				})


			},
			jumper: function(iid, num, type) {
				this.$router.push({
					name: 'datiyelc',
					query: {
						iid: iid,
						num: num,
						type: type
					}
				})

			},
			jiansuo: function() {
				//            console.log(155555555)
				let self = this;
				self.page = 1;
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/cp_index`,
					type: "post",
					dataType: "json",
					data: {
						token: this.token,
						cp_status: self.cepingtai,
						page: self.page,
						search: self.cha
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});
			},
			tan: function(e) {
				let self = this
				self.page = e
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/cp_index`,
					type: "post",
					dataType: "json",
					data: {
						token: this.token,
						cp_status: self.cepingtai,
						page: self.page,
						search: self.cha,
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});
			},
			ceping: function(a) {
				let self = this;
				self.cepingtai = a;
				self.page = 1;
				$.ajax({
					url: process.env.apiUrl + `saas/ceping/cp_index`,
					type: "post",
					dataType: "json",
					data: {
						token: this.token,

						cp_status: self.cepingtai,
						page: self.page,
						search: self.cha
					},
					success: function(data) {
						self.biaonum = Number(data.map.count);
						self.pageone = Number(data.map.pageone);
						self.list = data.data;
						self.pagetotal = data.map.pagetotal
					}
				});

			}

		},
		mounted: function() {
			//        $.cookie('centre_id','223');
			this.token = $.cookie("token");
			let self = this;
			$.ajax({
				url: process.env.apiUrl + `saas/ceping/cp_index`,
				type: "post",
				dataType: "json",
				data: {
					token: this.token,
					cp_status: 2
				},
				success: function(data) {
					console.log(data);
					self.biaonum = Number(data.map.count);
					self.pageone = Number(data.map.pageone);
					self.list = data.data;
					self.pagetotal = data.map.pagetotal
				}
			});

		}



	}
</script>

<style scoped>
	body .yixiaolie {
		/*font-size: 18px;*/
	}

	.borziBtn.active {
		background: #E6BE8A;
		color: #fff;
		border: none;
	}

	.header {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.tablebtnBox {

		display: flex;
		justify-content: space-between;
	}

	.tableBox {
		padding: 0 10px;

	}

	body,
	p {
		margin: 0;
		padding: 0;
		font-size: 11px;
	}

	.boxr {
		width: 224px;
		height: 54px;
		/*line-height: 1.08;*/
		/*background: green;*/
		box-sizing: border-box;
		padding-left: 20px;
		display: flex;
		display: -webkit-flex;
		align-items: center;
	}

	#app {
		width: 100%;
		height: 100vh;
		display: flex;
		display: -webkit-flex;
		flex-direction: column;
	}

	.mainBox {
		display: flex;
		display: -webkit-flex;
		flex: 1;


	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.leftBox {
		width: 70px;
		height: 100%;
		background: #E6BE8A;
		border-radius: 10px 0 0 10px;
		box-sizing: border-box;
		padding-top: 30px;
		padding-bottom: 30px;

	}

	.rightBox {
		flex: 1;
		flex-direction: column;
	}

	.mainbox {
		flex: 1;
	}

	.bottombox {
		height: 40px;
		justify-content: center;
		align-items: center;
		color: #666;
		width: 100%;
		background: #f1f1f1;
	}

	.mainhead {
		display: flex;
		display: -webkit-flex;
		height: 43px;
		background: #f1f1f1;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 8px;
		padding-right: 8px;
	}

	nav {
		width: 100%;
		height: auto;
		overflow-y: scroll;
		overflow-x: visible;
	}

	.navlist {
		height: 55px;
		justify-content: center;
		align-items: center;

	}

	.tubiaoc {
		display: inline;
		text-align: center;
	}

	.navimg {
		width: 28px;
		height: 28px;
	}

	.navinfo {
		color: #fff;
		margin-top: -2.5px;
	}

	.logotitle {
		font-size: 14px;
		color: #6355a2;
		margin-left: 15px;
		font-weight: 700;
		margin-top: 13px;
		letter-spacing: 0.5px;
	}

	.mainbox2 {
		flex-direction: column;
		flex: 1;
	}

	.headleft {
		height: 24px;
	}

	.headright {
		height: 24px;
		justify-content: flex-end;
		align-items: center;
	}

	.jumpindex {
		width: 55px;
		height: 24px;
	}

	.centername {
		line-height: 24px;
		margin-left: 10px;
	}

	.HeadPurBtn {
		padding: 3px 9px;
		border-radius: 13px;
		background: #E6BE8A;
		color: #fff;
	}

	.HeadHelpBtn {
		width: 50px;
		margin-left: 15px;
	}

	.inner_body {
		background: #f1f1f1;
	}



	.zaixiankef .el-dialog__body {
		padding: 10px 10px;

	}

	.zaixiankef .el-dialog__body p {
		font-size: 11px;
	}


	.zaixiankef .el-dialog .el-dialog__header {
		background: #E6BE8A;
		text-align: center;
		padding: 8px;
		/*border-radius: 10px 10px 0 0;*/

	}

	.zaixiankef .el-dialog .el-dialog__header .el-dialog__title {
		color: #fff;
		font-size: 18px;
	}

	.zaixiankef .el-dialog__headerbtn {
		top: 8px;
		right: 8px;
		font-size: 15px;
	}

	.zaixiankef .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	.tanchuang2 .el-dialog__body {
		padding: 15px;
		height: 270px;
		overflow-y: scroll;
	}

	.tanchuang2 .el-dialog__footer {
		border-top: 1px solid #e5e5e5;
	}

	.clearfloat:after {
		display: block;
		clear: both;
		content: "";
		visibility: hidden;
		height: 0
	}

	.clearfloat {
		zoom: 1
	}

	.yongtou {
		float: right;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yongtou2 {
		float: left;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yLbox {
		margin-right: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #fdb06a;
		border-radius: 10px;
	}

	.yLbox2 {
		margin-left: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #eee;
		border-radius: 10px;
	}

	.fasongBtn {
		width: 130px;
		height: 32px;
		text-align: center;
		line-height: 32px;
		color: #fff;
		font-size: 16px;
		border-radius: 16px;
		float: left;
		cursor: pointer;
		margin-top: 20px;
		background: #fdb06a;
		box-shadow: #f7dcc4 3px 5px 10px;
	}

	.genjilist {
		list-style: none;
		padding: 0;
	}


	.genjilist li {
		height: 35px;
		box-sizing: border-box;
		line-height: 35px;
		text-align: center;
		color: #E6BE8A;
		background: #f1f1f1;
		border-bottom: 1px solid #d2cef3;
	}
</style>
<style>
	body .el-popover {
		min-width: 50px;
		padding: 0;
	}

	[v-cloak] {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/cepingyu.vue